'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { I18nextProvider } from 'react-i18next';

import { CustomThemeProvider, ThemeContextProvider } from '@kawaak/theme';

import i18n from './i18n';
import { InfluenceClientProvider } from './providers/influence-client-provider';
import StyledComponentsRegistry from './registry';

type Props = {
  children: React.ReactNode;
};

const Providers = ({ children }: Props) => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <StyledComponentsRegistry>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <ThemeContextProvider>
            <CustomThemeProvider>
              <InfluenceClientProvider>{children}</InfluenceClientProvider>
            </CustomThemeProvider>
          </ThemeContextProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </StyledComponentsRegistry>
  );
};

export default Providers;
